import { Spin } from 'antd';
import { useThemeTokens } from '../../states/theme.atom';

function SpinPage() {
  const { tokens } = useThemeTokens();

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 position-fixed top-0 start-0 w-100">
      <Spin size="large" style={{ color: tokens.colorPrimary as string }} />
    </div>
  );
}

export default SpinPage;
